export enum TaskTypeEnum {
    Check = 'CHECK',
    Input = 'INPUT',
    Options = 'OPTIONS'
  }